import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-no-search-results',
    templateUrl: './no-search-results.component.html',
    styleUrls: ['./no-search-results.component.scss'],
})
export class NoSearchResultsComponent implements OnInit {
    @Input() query: string;
    @Input() noSearchResults: boolean;

    constructor() {}

    ngOnInit(): void {}
}
